import React, { memo } from 'react'
import { Icon } from '@winnin/winnin_ui.components.icon'
import './index.scss'

const QuestionMarkTooltip = ({ title, position = 'tooltipped-n', fill = 'var(--primary_light1)' }) => {
  return (
    <div className={`tooltipped ${position} tooltipped-multiline QuestionMarkTooltip`} aria-label={title}>
      <Icon width={24} height={24} icon="questionMark" fill={fill} />
    </div>
  )
}

export default memo(QuestionMarkTooltip)
